import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth-context";

/**
 * Root route - redirects to appropriate route based on auth state
 * With BFF, we can't check session server-side, so this is a client route
 */
export default function RootRoute() {
  const navigate = useNavigate();
  const { bootstrapState, refresh, userId, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading || bootstrapState === "unavailable" || bootstrapState === "inactive") {
      return;
    }

    if (userId) {
      // User is authenticated, redirect to default app route
      void navigate("/analytics", { replace: true });
      return;
    }

    // No session, redirect to login
    void navigate("/login", { replace: true });
  }, [bootstrapState, userId, isLoading, navigate]);

  if (bootstrapState === "unavailable") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
        <div className="text-center space-y-4">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Unable to load your session</h1>
            <p className="mt-2 text-gray-600">
              Your session may still be valid, but the app could not finish bootstrapping.
            </p>
          </div>
          <Button
            onClick={() => {
              void refresh();
            }}
          >
            Retry
          </Button>
        </div>
      </div>
    );
  }

  // Show loading state while checking auth
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[color:var(--rf-color-primary)] mx-auto mb-4"></div>
        <p className="text-gray-600">Loading...</p>
      </div>
    </div>
  );
}
